import { useState, useEffect, useRef } from 'react';
import Bredcrum from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import { Tablescom } from '../../components/tablescomp';
import { userservices } from '../../services/userServices';
import { productservices } from '../../services/productServices';
import { supplierservices } from "../../services/supplierServices";
import { Titlebar, Searchbox } from '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router";
import { Dialog } from 'primereact/dialog';
import { localurl } from '../../constant';
import { convertFileToBase64 } from '../../helpers/base64conversion';
import { Toast } from "primereact/toast";
import { TabMenu } from 'primereact/tabmenu';
import {exportToExcel} from '../../helpers/exporttoexcel';
import { Tab } from 'bootstrap';
import { Badge } from 'primereact/badge';
const Supplier = () => {

  const navigate = useNavigate();
  const [quickFilterText, setQuickFilterText] = useState('');
  const [users, setUsers] = useState([]);
  const [results, setResults] = useState([]);
  const [userloaded, setUserloaded] = useState(true);
  const [visible, setVisible] = useState(false);
  const [popvisible, setPopvisible] = useState(false);
  const [deleleteid, setDeleleteid] = useState(false);
  const [viewsupplier, setViewsupplier] = useState([]);
  const [viewvisible, setViewvisible] = useState(false);
  const toast = useRef(null);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // 🔄 dynamic page size

  useEffect(() => {
    getallsuppliers('',currentPage,pageSize);
  }, [currentPage,pageSize]);

  const deletesupplier = (id) => {
    setPopvisible(true);
    setDeleleteid(id);
  }
  const [colDefs, setColDefs] = useState([
    {
      headerName: "SR NO",
      valueGetter: (params) => params.node.rowIndex + 1,
      width:80
    },
    { headerName: "Supplier", field: "name",tooltipField: "name"  },
    { headerName: "Email", field: "email",tooltipField: "email" },
    {
      headerName: 'Phone No', field: "phone", cellRenderer: (params) => {
        return (
          <>
            <Tag style={{ background: 'transparent',color:'grey' }}>
              <div className="flex align-items-center">
                  <Badge value={<i className="fa fa-phone text-xs"></i>}></Badge>
                &nbsp; &nbsp;
                {params.data.phone}

              </div>
            </Tag>
          </>
        );
      }
    },
    { headerName: "Address", field: "address",tooltipField: "address"},
    { headerName: "Type", field: "type" },
    
    // { headerName: "Location",field: "address",cellRenderer: (params) => {
    //     return (
    //         <Tag severity="success" value={params.getValue()} rounded></Tag>
    {
      headerName: "Status", field: "status", cellRenderer: (params) => {
        return (
          params.getValue() == 1 ? <Tag severity="success" value="Active" rounded/> : <Tag severity="danger" value="In-Active" rounded/>

        );
      }
    },
    // { headerName: "Phone",field: "phone" },
    // { headerName: "Supplier type",field: "type" },
    // { headerName: "Freight Charges",

    //     field: "name" },
    // { headerName: "Notes",field: "total_stock_used_across_products" },


    {
      headerName: "Action",
      cellRenderer: (params) => {
        // console.log("params");
        // console.log(params.data.id);
        return (
          <>
            <button class="btn  btn-xs btn-primary btn-border-none custom-btn-color2" onClick={(e) => editredirect(params.data.id, params.data)}><i class="icon icon-note  color-white"></i></button>
            &nbsp;
            <button class="btn btn-danger btn-xs btn-white btn-border-none" onClick={(e) => deletesupplier(params.data.id)} ><i class="icon icon-trash  color-white"></i></button>
            &nbsp;
            <button class="btn btn-success btn-xs btn-white btn-border-none" onClick={(e) => viewsupplierdata(params.data.id)}><i class="icon icon-eye  color-white"></i></button>
          </>

        );
      }
    }
  ]);

  const items = [
    {
      label: 'All',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('all'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'Active',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('active'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'In-Active',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('inactive'),
      //  template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Whole Seler',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('wholeseler'),
      //  template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Distributor',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('distributor'),
      //  template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Retailer',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('retailer'),
      //  template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Manufacturer',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('manufacturer'),
      //  template: (item) => itemRenderer(item, 1)
    },
  ];

  const handleStockFilter = (status) => {
      getallsuppliers(status,currentPage,pageSize);
  }


  const editredirect = (id, Data) => {
    navigate(`/editsupplier/${id}`, { state: { supplier: Data } });
  }
    const handleNext = () => {
      if (currentPage < Math.ceil(totalRows / pageSize)) {
        setCurrentPage(currentPage + 1);
      }
    };
  
    const handlePrevious = () => {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    };
      const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getallsuppliers('',1, newSize);       // reload with new size
  };

  const getallsuppliers = (status = 0,page,pageSize) => {
    setUserloaded(true);
    supplierservices.getbulkdata(status,page,pageSize).then((response) => {
      if (response.status == 200) {
        setResults(response.data.data);
        console.log(response.data.total)
        setTotalRows(response.data.total);
        setCurrentPage(response.data.current_page);
        setUserloaded(false);
      } else {
        setResults([]);
        setUserloaded(false);
        // setUsers([]);
        // setUserloaded(true);
      }
    }).catch((error) => {
      setResults([]);
      setUserloaded(false);
      // setUsers([]);
      // setUserloaded(true);
    });
  }

  const addproductnavigate = () => {
    // navigate.  
    navigate('/addingredient');
  }

  const uploadsupplier = async (e) => {
    e.preventDefault();
    let file = e.target.file.files[0];
    const base64 = await convertFileToBase64(file);
    supplierservices.createmultisupplier(base64).then((response) => {

    }).catch((error) => {

    });
  }

  const viewsupplierdata = (id) => {
    supplierservices.getbulkdata(id).then((response) => {
      if (response.status == 200) {
        setViewsupplier(response.data.data);
        setViewvisible(true);
      }
    }).catch((error) => {

    });
  }

  const deletesupplierdata = () => {
    if (deleleteid) {
      supplierservices.deletesupplier(deleleteid).then((response) => {
        if (response.status == 200) {
          setPopvisible(false);
          setDeleleteid(false);
          toast.current.show({ severity: 'success', summary: 'Sale', detail: 'Supplier deleted successfully' });
          getallsuppliers('',currentPage,pageSize);
        }
      }).catch((error) => {

      });
    }

  }

  const handleExport = () =>{
      exportToExcel({data:results,filename:'stock'});
  }

  return (
    <>
      <Toast ref={toast} />
      {/* <Bredcrum title={'Suppliers'} divider={false} /> */}
      <Dialog
        header="⚠️ Confirm Deletion"
        visible={popvisible}
        style={{ width: '30vw', borderRadius: '10px' }}
        onHide={() => setPopvisible(false)}
        modal
      >
        <p className="mb-4" style={{ fontSize: '1rem' }}>
          Are you sure you want to delete this supplier?
        </p>

        <div className="d-flex justify-content-end gap-2">
          <button
            className="btn btn-secondary rounded-pill px-4"
            onClick={() => setPopvisible(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger rounded-pill px-4"
            onClick={deletesupplierdata}
          >
            Delete
          </button>
        </div>
      </Dialog>

      {/* <Dialog
        header="Supplier Data View"
        visible={viewvisible}
        style={{ width: '60vw' }}
        onHide={() => setViewvisible(false)}
        // footer={footerContent}
        modal
        className="p-fluid"
      >
        <div className="card-body">
          <div className="container mt-4">
            {viewsupplier.map((row, index) => (
              <div className="row" key={index}>
               
                <div className="col-md-6 form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={row.name || ''} readOnly
                  />
                </div>

                
                <div className="col-md-6 form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={row.email || ''} readOnly
                  />
                </div>

                
                <div className="col-md-6 form-group">
                  <label>Phone</label>
                  <input
                    type="tel"
                    name="phone"
                    className="form-control"
                    value={row.phone || ''} readOnly
                  />
                </div>

               
                <div className="col-md-6 form-group">
                  <label>Address</label>
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    value={row.address || ''} readOnly
                  />
                </div>

               
                <div className="col-md-6 form-group">
                  <label>Shop Name</label>
                  <input
                    type="text"
                    name="shopname"
                    className="form-control"
                    value={row.shopname || ''} readOnly
                  />
                </div>

            
                <div className="col-md-6 form-group">
                  <label>Type</label>
                  <select className="form-control" name="type">
                    <option value={row.type}>{row.type}</option>

                  </select>
                </div>

                
                <div className="col-md-6 form-group">
                  <label>Photo URL</label>
                  <input
                    type="text"
                    name="photo"
                    className="form-control"
                    value={row.photo || ''} readOnly
                  />
                </div>

               
                <div className="col-md-6 form-group">
                  <label>Account Holder</label>
                  <input
                    type="text"
                    name="account_holder"
                    className="form-control"
                    value={row.account_holder || ''} readOnly
                  />
                </div>

                
                <div className="col-md-6 form-group">
                  <label>Account Number</label>
                  <input
                    type="text"
                    name="account_number"
                    className="form-control"
                    value={row.account_number || ''} readOnly
                  />
                </div>

               
                <div className="col-md-6 form-group">
                  <label>Bank Name</label>
                  <input
                    type="text"
                    name="bank_name"
                    className="form-control"
                    value={row.bank_name || ''} readOnly
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Dialog> */}
       <Dialog visible={viewvisible} position='top' modal style={{ width: '110rem' }} onHide={() => setViewvisible(false)}>
            
              <table className='table-bordered'>
                <tbody>
                  <tr>
                    <th colSpan={10}><h3 className='text-success'>Supplier Info: </h3></th>
                   
                  </tr>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Shop Name</th>
                    <th>Type</th>
                    <th>Photo URL</th>
                    <th>Account Holder</th>
                    <th>Account Number</th>
                    <th>Bank Number</th>
                  </tr>
                   {viewsupplier.map((row, index) => (
                  <tr>
                    <td>{row.name}</td>
                    <td>{row.email}</td>
                    <td>{row.phone}</td>
                    <td>{row.address}</td>
                    <td>{row.shopname}</td>
                    <td>{row.type}</td>
                    <td>{row.photo}</td>
                    <td>{row.account_holder}</td>
                    <td>{row.account_number}</td>
                    <td>{row.bank_name}</td>
                  </tr>
                   ))}
                  {/* {displayIngredients()} */}
                </tbody>
              </table>
            
          </Dialog>

      <div class="row">
        <div className='col-md-12 mb-2 mt-2'>
          <div className='flex-box flex-between'>
            <div className=''>
              <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5' onClick={() => navigate('/addsupplier')}>Add Supplier</button>
              &nbsp;
              &nbsp;
              

              <button className='btn rounded-pill  custom-btn-br-color ps-5 pe-5 btn-dark' onClick={() => setVisible(true)}>Add Multi Suppliers</button>

              <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={() => { if (!visible) return; setVisible(false); }}>
                <div className="container py-5">
                  <div className="card shadow-lg rounded-4 p-4">
                    <h2 className="mb-4 text-center text-primary">Excel Multiple Data Upload</h2>

                    <div className="text-center mb-4">
                      <a
                        href={localurl + "/templates/component.xlsx"}
                        download
                        className="btn btn-outline-primary rounded-pill px-4"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Download Excel Template
                      </a>
                    </div>

                    <form id="uploadForm" onSubmit={(e) => uploadsupplier(e)}>
                      <div className="mb-3">
                        <label htmlFor="file" className="form-label fw-semibold">
                          Upload Excel File
                        </label>
                        <input
                          type="file"
                          className="form-control form-control-lg"
                          id="file"
                          name="file"
                          accept=".xlsx, .xls"
                          required
                        />
                      </div>

                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-primary rounded-pill px-5 py-2 custom-btn-color"
                        >
                          Upload
                        </button>
                      </div>
                    </form>

                    <div id="status" className="status mt-4 text-center text-success fw-medium"></div>
                  </div>
                </div>

              </Dialog>
            </div>

            <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)} />
          </div>
        </div>


        {/* <Titlebar text={'Master  Supplier List'} /> */}
        <div className="col-md-12 mt-3">
          <div className='row'>
            <div className='col-md-8'>
                  <TabMenu model={items}  />
            </div>

            <div className='col-md-4'>
                <div> 
                  <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                    <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                  </div>
            </div>
          </div>
          <div className='card'>
            <div className='card-body card-body-style'>
              <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText}
              paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                     totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext} 
                     handlePrevious={handlePrevious}
                     handlePageSizeChange={handlePageSizeChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Supplier;